<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg" :loading="loading">
          <v-toolbar color="#f8f9fb" elevation="0">
            <v-toolbar-title>{{ $t("society.list.title") }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="float-right" color="primary" to="/superadmin/society/add">
                <v-icon left>
                  mdi-plus
                </v-icon>
                Add Society
              </v-btn>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text class="#f4f5f7">
            <v-data-table :headers="headers" :items="socities" :search="search" class="elevation-3">
              <template v-slot:top>
                <v-text-field
                  v-model="search"
                  label="Search"
                  clearable
                  append-icon="mdi-magnify"
                  single-line
                  hide-details
                  class="col-md-6"
                  @input="sessionStorage(search)"
                ></v-text-field>
              </template>
              <template v-slot:item.type="{ item }">
                {{ residentTypes.find((type) => type.id == item.type).name }}
              </template>

              <template v-slot:item.address="{ item }">
                {{
                  `${item.address} , ${item.city}, ${item.state}, ${item.country}`
                }}
              </template>

              <template v-slot:item.contact_person_number="{ item }">
                {{ item.country_code }} {{ item.contact_person_number }}
              </template>

              <template v-slot:item.is_active="{ item }">
                <v-switch
                  v-model="item.is_active"
                  @change="changeStatus(item.id, index)"
                ></v-switch>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      v-bind="attrs"
                      v-on="on"
                      :to="'/superadmin/society/list/' + item.id + '/details'"
                    >
                      <v-icon small> mdi-eye </v-icon>
                    </v-btn>
                  </template>
                  <span>View Details</span>
                </v-tooltip>
                <router-link
                  :to="'/superadmin/society/edit/' + item.id"
                  class="text-decoration-none"
                >
                  <v-btn
                    icon
                    color="secondary"
                    name="edit_notice"
                    title="Edit Notice"
                  >
                    <v-icon small> mdi-pencil </v-icon>

                  </v-btn>
                  
                </router-link>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      loading: false,
      search: "",
      headers: [
        {
          text: `${this.$t("society.list.headers.type")}`,
          value: "type",
          width: "12%",
        },
        {
          text: `${this.$t("society.list.headers.societyCode")}`,
          value: "society_code",
          width: "10%",
        },
        {
          text: `${this.$t("society.list.headers.name")}`,
          align: "start",
          value: "name",
          width: "15%",
        },
        {
          text: `${this.$t("society.list.headers.address")}`,
          value: "address",
          width: "20%",
        },
        {
          text: `${this.$t("society.list.headers.contactPersonName")}`,
          value: "contact_person_name",
          width: "12%",
        },
        {
          text: `${this.$t("society.list.headers.contactPersonNumber")}`,
          value: "contact_person_number",
          sortable: false,
          width: "15%",
        },
        {
          text: `${this.$t("society.list.headers.enableDisable")}`,
          value: "is_active",
          width: "8%",
          sortable: false,
        },
        {
          text: `${this.$t("society.list.headers.actions")}`,
          value: "actions",
          width: "10%",
          sortable: false,
        },
      ],
      socities: [],
      residentTypes: [
        {
          id: 1,
          name: "Residential",
        },
        {
          id: 2,
          name: "Commercial",
        },
        {
          id: 3,
          name: "Resedential & Commercial",
        },
      ],
    };
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    getSocieties() {
      let _self = this;

      _self.$axios.get("superadmin/society").then((response) => {
        let data = response.data;

        if (data.status) {
          _self.socities = data.socities;
        } else {
          _self.setAlert({
            showAlert: true,
            variant: "red accent-3",
            timeout: "2000",
            message: data.message,
          });
        }
      });
    },
    changeStatus(id) {
      let _self = this;
      _self.loading = true;

      _self.$axios
        .post("superadmin/society/" + id + "/changeStatus")
        .then((response) => {
          let data = response.data;

          _self.loading = false;

          if (data.status) {
            _self.setAlert({
              showAlert: true,
              variant: "green accent-4",
              timeout: "2000",
              message: data.message,
            });
          } else {
            _self.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
    sessionStorage(search) {
      if (search === null || search === "" || search === undefined) {
        sessionStorage.removeItem("society_search");
      } else {
        sessionStorage.setItem("society_search", search);
      }
    },
  },
  mounted() {
    this.getSocieties();
    this.search = sessionStorage.getItem("society_search");
  },
};
</script>